/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import { AlertTriangle } from "lucide-react";
import React from "react";

export const MaintenanceBanner: React.FC = () => {
  if (
    process.env["NEXT_PUBLIC_MAINTENANCE_MODE"]?.toLowerCase() !== "true" &&
    process.env["NEXT_PUBLIC_MAINTENANCE_MODE"] !== "1"
  ) {
    return null;
  }
  return (
    <div
      role="status"
      aria-live="polite"
      className="w-full border-b bg-warning-50 border-warning-200 text-warning-700"
    >
      <div className="mx-auto max-w-screen-xl px-4 py-2 flex items-center gap-2 text-sm">
        <AlertTriangle className="h-4 w-4 text-warning-500" />
        The system is in maintenance mode. Some features may be unavailable.
      </div>
    </div>
  );
};
